/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

//@ts-nocheck

import React, { useEffect, useRef, useState } from 'react';

import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { InputGroup } from 'react-bootstrap';

import * as S from './styles';

export interface INumberInputProps {
  placeholder?: string;
  policyOptions?: any;
  currency?: string;
  min?: string;
  max?: string;
  onInputValueSubmit?(value: number): void;
  value?: number;
}

const SwalWithBootstrapButtons = withReactContent(
  Swal.mixin({
    customClass: {
      confirmButton: 'btn btn-primary me-3',
      cancelButton: 'btn btn-secondary',
    },
    buttonsStyling: false,
  })
);

export const NumberInput = (props: INumberInputProps) => {
  const {
    placeholder,
    policyOptions,
    currency,
    min,
    max,
    value,
    onInputValueSubmit,
  } = props;
  const [error, setError] = useState<any>(null);
  const numberInputRef = useRef(null);

  useEffect(() => {
    if (
      value >= policyOptions?.lowerBound &&
      value <= policyOptions?.upperBound
    ) {
      setError(null);
    }
  }, [value]);

  const onChange = (e: any) => {
    console.log(`event:target:value`, e.target.value);
    if (e.target.value < policyOptions?.lowerBound) {
      setError(`Minimum ${policyOptions?.subTitle} Amount is ${min}`);
    }
    if (e.target.value > policyOptions?.upperBound) {
      setError(`Maximum ${policyOptions?.subTitle} Amount is ${max}.`);
    }
    if (
      e.target.value >= policyOptions?.lowerBound &&
      e.target.value <= policyOptions?.upperBound
    ) {
      setError(null);
      onInputValueSubmit && onInputValueSubmit(e.target.value);
    }
  };

  return (
    <div>
      <S.GroupInput className="mb-2">
        <InputGroup.Text>{currency}</InputGroup.Text>
        <S.NumberForm
          key={value}
          type="number"
          placeholder={`Enter ${placeholder}`}
          ref={numberInputRef}
          defaultValue={value}
          onChange={onChange}
          autoFocus
        />
        {/* <S.GroupText id="" className="bg-secondary" onClick={onNumberInputSubmit}>
        Go
      </S.GroupText> */}
      </S.GroupInput>
      {error && <S.AlertComp variant="danger">{error}</S.AlertComp>}
    </div>
  );
};
